import * as React from 'react';
export const axosSvg = React.forwardRef(function axosSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#1B3361',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M7.989 6.253a.868.868 0 0 0-1.224 0l-.512.512a.868.868 0 0 0 0 1.224l8.013 8.014-8.013 8.003a.89.89 0 0 0 0 1.235l.512.5a.858.858 0 0 0 1.224 0l9.75-9.738-9.75-9.75Z',
      fill: '#F9A65A',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'm25.742 6.765-.5-.512a.89.89 0 0 0-1.236 0l-6.79 6.8 1.736 1.737 6.79-6.801a.858.858 0 0 0 0-1.224Zm0 18.476-.5.5a.867.867 0 0 1-1.236 0l-6.79-6.789 1.736-1.736 6.79 6.79a.87.87 0 0 1 0 1.235Z',
      fill: '#FEFEFE',
    }),
  );
});
axosSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var axos = {
  category: 'brand',
  colorable: false,
  name: 'axos',
  svg: axosSvg,
};
